import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Select, MenuItem, Box, CircularProgress, Typography } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import { useUnion } from '../contexts/UnionContext';

function UnionSwitcher() {
  const { t } = useTranslation();
  const { unions, activeUnion, loading, switchUnion, refreshUnions } = useUnion();
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = async (event) => {
    const unionId = event.target.value;
    const success = await switchUnion(unionId);
    if (success) {
      await refreshUnions();
      navigate(location.pathname, { replace: true });
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CircularProgress size={18} sx={{ color: 'rgba(255,255,255,0.7)' }} />
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>{t('common.loading')}</Typography>
      </Box>
    );
  }

  if (!unions || unions.length === 0) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <BusinessIcon sx={{ color: 'rgba(255,255,255,0.4)', fontSize: 18 }} />
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.4)' }}>{t('switcher.noUnion')}</Typography>
      </Box>
    );
  }

  return (
    <Select
      value={activeUnion?.id || unions[0].id}
      onChange={handleChange}
      size="small"
      variant="outlined"
      renderValue={(id) => {
        const u = unions.find((x) => x.id === id);
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <BusinessIcon sx={{ fontSize: 16, color: 'rgba(255,255,255,0.8)' }} />
            <span>{u?.name ?? '—'}</span>
          </Box>
        );
      }}
      sx={{
        color: 'white',
        minWidth: 180,
        maxWidth: 280,
        '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.25)' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.5)' },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.7)' },
        '.MuiSvgIcon-root': { color: 'rgba(255,255,255,0.7)' },
        fontSize: 14,
      }}
    >
      {unions.map((union) => (
        <MenuItem key={union.id} value={union.id}>
          {union.name}
        </MenuItem>
      ))}
    </Select>
  );
}

export default UnionSwitcher;
